const httpClient = require('../../utils/axios');

class APIService {
  constructor() {
    this.httpClient = httpClient;
  }
}

module.exports = APIService;
